import React from "react";
import Grid from "@material-ui/core/Grid";

const ProgressBar: React.FC<{ percentComplete: string }> = ({ percentComplete }) => (
  <Grid item xs={12}>
    <div className="progress">
      <div className="progress-bar" style={{ width: percentComplete }} >
        <span className="sr-only">{percentComplete}</span>
      </div>
    </div>
  </Grid>
);

export default ProgressBar;
